import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/skill-icon.svg'


const _hoisted_1 = { class: "d-flex ga-5 align-center" }
const _hoisted_2 = { class: "d-flex flex-column align-center" }
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "d-flex ga-3 ga-md-8 justify-space-between align-center" }
const _hoisted_5 = { class: "d-flex ga-3 ga-md-8 align-center" }
const _hoisted_6 = { class: "d-flex ga-3 ga-md-8 align-center" }
const _hoisted_7 = { class: "f-body-1 hidden-sm-and-down" }
const _hoisted_8 = { class: "f-body-1 hidden-sm-and-down" }
const _hoisted_9 = {
  key: 0,
  class: "hidden-sm-and-down"
}
const _hoisted_10 = { class: "f-body-1 hidden-sm-and-down" }
const _hoisted_11 = { class: "d-flex ga-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "f-body-1 hidden-sm-and-down" }, "Favorite Skill", -1)),
      _createVNode(_component_v_checkbox, {
        readonly: _ctx.isHiringmanager,
        disabled: _ctx.islimited(_ctx.skill.IsTopSkill) || _ctx.loading,
        modelValue: _ctx.skill.IsTopSkill,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.skill.IsTopSkill) = $event)),
        onChange: _ctx.changeSkillStatus,
        "hide-details": ""
      }, null, 8, ["readonly", "disabled", "modelValue", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_card, { class: "b-dark" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createElementVNode("img", {
                      class: "item-card-icons",
                      src: _imports_0
                    }, null, -1)),
                    _createElementVNode("h4", null, _toDisplayString(_ctx.getSkillName(_ctx.skill.SkillId)), 1)
                  ]),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.skill.Level), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.skill.TotalExperienceYears), 1),
                  (!_ctx.isHiringmanager && _ctx.skill.Certificate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.skillDownload(_ctx.skill.SkillId)), ["prevent"])),
                          target: "_blank"
                        }, [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode("mdi-attachment")
                            ])),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_10, "Assessment: " + _toDisplayString(_ctx.skill.Assessment), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (!_ctx.isHiringmanager)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        icon: "mdi-pen",
                        class: "c-black b-white",
                        disabled: _ctx.loading,
                        onClick: _ctx.edit
                      }, null, 8, ["disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  (!_ctx.isHiringmanager)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        icon: "mdi-delete",
                        class: "c-black b-white",
                        disabled: _ctx.loading,
                        onClick: _ctx.remove
                      }, null, 8, ["disabled", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}